import React from 'react';
import { Dialog as MuiDialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';

interface DialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
  content: React.ReactNode;
  showCloseButton?: boolean;
  width?: number;
}

const Dialog: React.FC<DialogProps> = ({ open, onClose, title, content, showCloseButton = true, width }) => {
  return (
    <MuiDialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        style: {
          backgroundColor: 'rgba(0, 0, 0, 0.65)',
          backdropFilter: 'blur(8px)',
          WebkitBackdropFilter: 'blur(8px)',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          borderRadius: '12px',
          ...(width ? { width: `${width}px` } : {})
        },
      }}
      sx={{
        '& .MuiPaper-root': {
          margin: { xs: '16px', sm: '32px' },
          width: { xs: 'calc(100% - 32px)', sm: '600px' },
        },
        '& .MuiDialogTitle-root': {
          fontSize: { xs: '0.8rem', sm: '0.9rem' },
          color: 'text.primary',
          p: { xs: 2, sm: 3 },
          pb: { xs: 1.5, sm: 2 },
        },
        '& .MuiDialogContent-root': {
          p: { xs: 2, sm: 3 },
          pt: { xs: 0, sm: 0 },
        }
      }}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {typeof content === 'string' ? (
          <Typography>{content}</Typography>
        ) : (
          content
        )}
      </DialogContent>
      {showCloseButton && (
        <DialogActions>
          <Button onClick={onClose}>閉じる</Button>
        </DialogActions>
      )}
    </MuiDialog>
  );
};

export default Dialog;